const SUPPORTED_LOCALES = ['pt-BR', 'en-US', 'es-ES'];

export const getSpellCheckLang = (locale) =>
  SUPPORTED_LOCALES.includes(locale) ? locale : 'pt-BR';

export const applyQuillSpellCheck = (containerId, locale) => {
  const editor = document.getElementById(containerId)?.querySelector('.ql-container .ql-editor');
  if (editor) {
    editor.setAttribute('spellcheck', 'true');
    editor.setAttribute('lang', getSpellCheckLang(locale));
  }
};

export const detectBrowserForSpellCheckHelp = () => {
  if (typeof navigator === 'undefined' || !navigator.userAgent) return 'other';
  const ua = navigator.userAgent;

  if (/Edg\//.test(ua)) return 'edge';
  if (/Firefox\//.test(ua) && !/Seamonkey/.test(ua)) return 'firefox';
  if (/Chrome\//.test(ua) && !/Edg\//.test(ua) && !/OPR\//.test(ua)) return 'chrome';
  if (/Safari\//.test(ua) && !/Chrome\//.test(ua) && !/Chromium\//.test(ua)) return 'safari';
  return 'other';
};

export const SPELLCHECK_SETTINGS_PATH = {
  chrome: 'chrome://settings/languages',
  edge: 'edge://settings/languages',
  firefox: 'about:preferences#general',
};
